export const getSaleDeliveryList = state => {
    return state.list
}

export const getSaleDeliveryDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/saleDelivery/getters.js